export function formatTag(tag: string) {
  return (
    tag.charAt(0).toUpperCase() +
    tag.slice(1).replaceAll('_', ' ').replaceAll('api', 'API')
  )
}
